@use "../../../styles/breakpoint.module.scss" as *;

.inner {
    composes: safeContainer from "../../../styles/composable/layout.module.css";
    display: grid;
    grid-template-columns: 1fr 4fr 1fr;
    grid-template-areas: "logo progress actions";
    align-items: center;
    min-height: 77px;

    @media ($below-mobile) {
        grid-template-columns: 1fr 1fr;
        grid-template-areas:
            "logo actions"
            "progress progress";
        row-gap: var(--spacer-24);
        padding-block: var(--spacer-24);
    }

    > nav {
        grid-area: progress;
    }
}

.logo {
    width: 87px;
    height: auto;
    grid-area: logo;
    justify-self: start;
}

.actions {
    display: flex;
    align-items: center;
    gap: var(--spacer-24);
    grid-area: actions;
    justify-self: end;
    min-width: max-content;
}

.miniCartTrigger {
    font: var(--font-nav-16);
}

.close {
    width: var(--spacer-24);
    height: var(--spacer-24);
}
